// Read from environment variable
const backendUrl = import.meta.env.VITE_BACKEND_URL;

console.log('🔧 Environment check:');
console.log('📦 import.meta.env:', import.meta.env);
console.log('🌐 VITE_BACKEND_URL:', backendUrl);

// In development with Vite proxy, we use relative URLs
// In production, we need the full URL
export const API_BASE_URL = backendUrl ? `${backendUrl}/api/v1` : '/api/v1';
console.log('✅ API_BASE_URL configured as:', API_BASE_URL); 